<template>
  <div class="Wdgt-Content-Similar-Posts" v-if="posts?.length > 0 || isLoading">
    <p class="Wdgt-Content-Similar-Posts__ttl">Похожее</p>
    <LoaderCircle class="WWdgt-Content-Similar-Posts__ldr" :size="32" :color="'var(--blue-600)'" v-if="isLoading"/>
    <ul class="Wdgt-Content-Similar-Posts__list" v-else>
      <li class="Wdgt-Content-Similar-Posts__item" v-for="item in posts" :key="item.id">
        <AlphaPost :postId="parseInt(item.id)" :hideMenu="true" :isDate="true" v-if="props.isAlpha"/>
        <InfonoisePost :postId="parseInt(item.id)" :isDate="true" v-else/>
      </li>
    </ul>
  </div>
</template>

<script setup>
import {onMounted, onBeforeUnmount, ref, watch} from 'vue';
import {Props} from './scripts/props.js';
import {useStore} from 'vuex';
import {getSimilarPosts} from './api/getSimilarPosts';
//------------------------------------------
import AlphaPost from '@entities/Posts/AlphaPost/AlphaPost.vue';
import InfonoisePost from '@entities/Posts/InfonoisePost/InfonoisePost.vue';
import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
//------------------------------------------
const props = defineProps(Props());
const store = useStore();
//------------------------------------------
const DATA = props.post;
//------------------------------------------
const isLoading = ref(false);
const posts = ref([]);
//------------------------------------------
onMounted(() => {
  toGetSimilarPosts();
});
onBeforeUnmount(() => {

});
//------------------------------------------
const emit = defineEmits(['update-has-posts']);

// Следим за изменениями posts
watch(posts, (newPosts) => {
  emit('update-has-posts', newPosts.length > 0);
});
//------------------------------------------
//Отправить запрос на получение похожих постов
const toGetSimilarPosts = async () => {
  try {
    toToggleLoading(true);
    posts.value = await getSimilarPosts({object_id: DATA.id, content_type: DATA.content_type});
    posts.value.forEach(post => {
      const targetList = props.isAlpha
        ? store.state.ContentSystem.Alpha.list
        : store.state.ContentSystem.Infonoise.list;

      const mutation = props.isAlpha
        ? 'ContentSystem/Alpha/toAddNewPostWithoutRender'
        : 'ContentSystem/Infonoise/toAddNewPostWithoutRender';

      if (!(post.id in targetList)) {
        store.commit(mutation, post);
      } else {
        targetList[post.id].last_comment = post.last_comment;
      }
    });
  } catch (error) {
    console.error(error);
  } finally {
    toToggleLoading(false);
  }
}
//Переключить состояние процесса загрузки данных
const toToggleLoading = (status) => isLoading.value = status;
</script>

<style lang="scss">
@import './styles/_styles';
</style>
